<template>
  <div>
    <div class="main">
      <h2>お気に入り商品</h2>
      <div class="search">
        <div class="fl">
          <a href="javascript:;">全部({{ total }})</a>|
        </div>
        <div class="fr">
          <input type="text" placeholder="キーワード" v-model="val" />
          <img src="../../../assets/img/search2.png" alt />
        </div>
        <h3>
          <button @click="delAll">選択したアイテムを削除</button>
        </h3>
      </div>
      <div class="commodity">
        <ul>
          <li
            v-for="(item, index) in lists"
            :key="index"
            :class="{ li: item.checked == true }"
          >
            <div class="img">
              <router-link
                :to="
                  item.type == 'RAKUMART'
                    ? '/details?id=' + item.iid
                    : `/details1688?iid=${item.iid}&type=${item.type}${item.mi_id ? '&mi_id=' + item.mi_id : ''}`
                "
                target="_blank"
              >
                <img :src="item.pic" alt />
              </router-link>
              <!-- <a
                :href="
                  item.type == 'taobao'
                    ? 'https://item.taobao.com/item.htm?id=' + item.iid
                    : 'https://detail.tmall.com/item.htm?id=' + item.iid
                "
                v-else
                target="_blank"
              >
                <img :src="item.pic" alt />
              </a> -->
            </div>
            <p :title="item.title">{{ item.title }}</p>
            <p>
              <img
                src="../../../assets/img/1688.png"
                alt
                v-if="item.type == '1688'"
                class="mini-img"
              />
              <img
                src="../../../assets/img/logo1.png"
                alt
                v-else-if="item.type == 'RAKUMART'"
              />
              <span>￥{{ item.price }}</span>
            </p>
            <div class="caozuo">
              <input type="checkbox" name id v-model="item.checked" />
              <div class="img">
                <img src="../../../assets/img/biaoqian.png" alt />
              </div>
              <div class="img">
                <img
                  src="../../../assets/img/delete.png"
                  @click="favoriteDelete(item.id)"
                />
              </div>
            </div>
          </li>
        </ul>
        <div class="fenye">
          <div class="fenye">
            <el-pagination
              background
              @current-change="handleCurrentChange"
              :current-page="list.page"
              :page-size="list.pageSize"
              layout="total,prev, pager, next"
              :total="total"
            ></el-pagination>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { favoriteList, favoriteDelete } from "../../../api/API/commodity";
export default {
  data() {
    return {
      val: "",
      token: localStorage.getItem("token"),
      list: {
        mod: "inc",
        act: "ordersys",
        str: "favoriteList",
        token: "",
        page: 1,
        pageSize: 20,
      }, // 参数

      lists: [], //数据
      total: 0, // 总数
      arrID: [], // 批量删除id
    };
  },
  created() {
    this.favoriteList();
  },

  methods: {
    // 获取数据
    favoriteList() {
      this.list.token = this.token;
      favoriteList(this.list).then((res) => {
        console.log(res);
        if (res.code != 1) return;
        this.lists = res.data.list;
        this.total = res.data.total - 0;
      });
    },
    handleCurrentChange(val) {
      this.list.page = val;
      this.favoriteList();
    },
    // 删除
    favoriteDelete(id) {
      let list = {
        mod: "inc",
        act: "ordersys",
        str: "favoriteDelete",
        token: this.token,
        ids: id,
      };
      this.$confirm("こちらの商品削除されますか？?", "提示", {
        confirmButtonText: "確定",
        cancelButtonText: "キャンセル",
        type: "warning",
      })
        .then(() => {
          favoriteDelete(list).then((res) => {
            if (res.code != 1) {
              return this.$message({
                type: "error",
                message: res.msg,
              });
            }
            this.$message({
              type: "success",
              message: "削除成功",
            });
            this.favoriteList();
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "削除キャンセル",
          });
        });
    },
    // 批量删除
    delAll() {
      this.arrID = [];
      this.lists.forEach((item) => {
        if (item.checked == true) {
          this.arrID.push(item.id);
        }
      });
      let id = this.arrID.join(",");
      if (id == "") return this.$message.error("商品を選択してください");
      this.favoriteDelete(id);
    },
  },
};
</script>
<style lang='scss' scoped>
.main {
  width: 1208px;
  font-size: 16px;
  margin-bottom: 30px;
  overflow: hidden;
  h2 {
    height: 40px;
    background-color: #eee;
    line-height: 40px;
    padding-left: 20px;
    font-size: 20px;
    span {
      color: #f3c622;
    }
  }
  .search {
    // overflow: hidden;
    margin-top: 20px;
    margin-bottom: 40px;
    position: relative;
    a {
      color: #333;
      padding: 0 20px;
    }
    .fr {
      position: relative;
      margin-right: 30px;
    }
    input {
      width: 100px;
      height: 30px;
    }
    img {
      position: absolute;
      top: 5px;
      right: 5px;
      cursor: pointer;
    }
    h3 {
      padding-top: 30px;
      height: 40px;
      line-height: 60px;
      button {
        position: absolute;
        bottom: 0;
        right: 20px;
        height: 30px;
        line-height: 30px;
        background-color: #f3c622;
        color: #fff;
        font-size: 18px;
        padding: 0 10px;
        border-radius: 10px;
        cursor: pointer;
      }
    }
  }
  .commodity {
    overflow: hidden;
    ul {
      overflow: hidden;
      li {
        &:hover {
          border: 2px solid #f3c622;
        }
        &:hover .caozuo {
          display: block;
        }
        position: relative;
        float: left;
        width: 276px;
        height: 360px;
        border: 2px solid transparent;
        box-shadow: 0px 2px 12px 0px rgba(0, 0, 0, 0.2);
        margin-right: 20px;
        margin-bottom: 20px;
        .img {
          width: 276px;
          height: 280px;
          img {
            width: 276px;
            height: 280px;
          }
        }
        p {
          height: 40px;
          padding: 0 10px;
          overflow: hidden;
          line-height: 20px;
          img {
            float: left;
            margin-top: 10px;
            width: 40px;
          }
          span {
            float: right;
            margin-top: 5px;
            font-size: 20px;
            font-weight: 700;
            color: #f3c622;
            margin-right: 10px;
          }
        }
        .caozuo {
          position: absolute;
          top: 0;
          right: 0;
          display: none;
          input {
            width: 30px;
            height: 30px;
            margin-top: 10px;
          }
          .img {
            float: right;
            width: 50px;
            height: 50px;
            margin-left: 5px;
            background: #fff;
            text-align: center;
            cursor: pointer;

            img {
              width: 30px;
              height: 30px;
              margin-top: 10px;
            }
          }
        }
      }
      .li {
        border: 2px solid red !important;
      }
    }
  }
}
.fenye {
  width: 500px;
  margin: 30px auto;
  text-align: center;
}
/deep/.el-pagination.is-background .el-pager li:not(.disabled).active {
  background: #f3c622;
}
</style>
